/*
  FWUSA header behaviour, on top of Dawn's header-menu (assets/details-disclosure.js)
  and header-drawer (assets/global.js).

  Desktop menus open on hover for mouse users (fine pointer, 990px and up). Leaving starts a
  short close timer, so crossing the gap to the menu, or brushing past an edge, never closes it.
  Click, touch and keyboard keep Dawn's click-to-open behaviour.

  Mobile drawer sub menus fold open in place. A capturing click listener handles the nested
  summaries before Dawn's MenuDrawer sees them, so Dawn does not slide in a new panel or trap
  focus inside it; the native <details> toggle does the opening.
*/
(function () {
  "use strict";

  var CLOSE_DELAY = 200;
  var hoverQuery = window.matchMedia("(hover: hover) and (pointer: fine) and (min-width: 990px)");

  function setOpen(details, open) {
    var summary = details.querySelector("summary");
    if (open) details.setAttribute("open", "");
    else details.removeAttribute("open");
    if (summary) summary.setAttribute("aria-expanded", String(open));
  }

  document.querySelectorAll("header-menu").forEach(function (menu) {
    var details = menu.querySelector("details");
    if (!details) return;
    var summary = details.querySelector("summary");
    var timer;

    menu.addEventListener("pointerenter", function (event) {
      if (event.pointerType !== "mouse" || !hoverQuery.matches) return;
      window.clearTimeout(timer);
      document.querySelectorAll("header-menu details[open]").forEach(function (other) {
        if (other !== details) setOpen(other, false);
      });
      if (!details.open) {
        setOpen(details, true);
        details.dataset.fwHoverOpen = "true";
      }
    });

    menu.addEventListener("pointerleave", function (event) {
      if (event.pointerType !== "mouse" || !hoverQuery.matches || !details.dataset.fwHoverOpen) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        // Keep it open if the visitor tabbed into the menu meanwhile.
        if (menu.contains(document.activeElement) && document.activeElement !== summary) return;
        setOpen(details, false);
        delete details.dataset.fwHoverOpen;
      }, CLOSE_DELAY);
    });

    // A mouse click on a menu that hovering already opened would toggle it shut again.
    summary.addEventListener("click", function (event) {
      if (event.detail > 0 && hoverQuery.matches && details.dataset.fwHoverOpen && details.open) {
        event.preventDefault();
      }
    });

    details.addEventListener("toggle", function () {
      if (!details.open) delete details.dataset.fwHoverOpen;
    });
  });

  document.addEventListener(
    "click",
    function (event) {
      var summary = event.target.closest && event.target.closest("#menu-drawer details > summary");
      if (!summary) return;
      // Stop Dawn's MenuDrawer handler (it slides a panel in and traps focus); let <details> toggle natively.
      event.stopImmediatePropagation();
      var details = summary.parentElement;
      window.setTimeout(function () {
        summary.setAttribute("aria-expanded", String(details.open));
      });
    },
    true
  );
})();
